import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 7F5B9650-26E7-4A88-A6D1-2C338778651D
 * name apps
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/apps.svg
 * tags
 * - View 
 */
export const AppsIcon = createSvgIcon(<><path d="M16,20H20V16H16M16,14H20V10H16M10,8H14V4H10M16,8H20V4H16M10,14H14V10H10M4,14H8V10H4M4,20H8V16H4M10,20H14V16H10M4,8H8V4H4V8Z" /></>, 'AppsIcon');
export default AppsIcon